import React from 'react'
import { pt } from 'common-data/proptypehelpers'
import { log } from 'common-tools/index'
import { GridContainer, Grid, GridCell } from 'common-controls/Core/index'
import { LayoutContainer } from 'common-controls/App/index'

export const LayoutAreas = {
  NoHeader: 'NoHeader',
  NoFooter: 'NoFooter',
  BodyOnly: 'BodyOnly',
  All: 'All'
}

export class Layout extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      info: null
    }
  }

  componentDidCatch (error, info) {
    log.Error('Drawer Layout Error', { Error: error, Info: info })
    this.setState({
      hasError: true,
      error: error,
      info: info
    })
  }

  static propTypes = {
    className: pt.string
  }

  static defaultProps = {
    areaSetup: LayoutAreas.All
  }

  render () {
    const { children, onClick, noHandle, blue } = this.props
    const { hasError, error, info } = this.state
    const color = blue ? 'blue' : 'teal'

    if (hasError) {
      return <LayoutContainer>
        <GridContainer full>
          <Grid marginX>
            <GridCell smallOffSet={3} />
            <GridCell small={6}>
              <h3>Error</h3>
              <p><b>Message</b></p>
              <p>{error.message}</p>
              <p><b>Stack Trace</b></p>
              <p>{error.stack}</p>
              <p><b>Component Trace</b></p>
              <p>{info.componentStack}</p>
            </GridCell>
          </Grid>
        </GridContainer>
      </LayoutContainer>
    }

    return (

      <div className={`slide-pane-${color}`}>
        {noHandle
          ? null
          : <>
            <a onClick={onClick}><div className={`slide-arrow-${color}`}><i className="fas fa-angle-right"></i></div></a>
            <div className={`slide-pane-circle-${color}`}></div>
          </>
        }
        <Grid vertical frame>
          {children}
        </Grid>
      </div>

    )
  }
}

export default Layout
